export enum RegexContainer{
    emailPattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$",
    passwordPattern="(?=.*[0-9])(?=.*[!@#$%^&*()__+])[a-zA-Z0-9!@#$%^&*()__+]{8,11}",
    contactNumberPattern = '[0-9]{10}'
}